import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type UpsaleForBusiness = 'a' | 'b' | false;

interface UpsaleForBusinessTariffs {
    month: string[];
    year: string[];
}

const isUspaleForBusiness: UpsaleForBusiness = getFeature('upsale-for-business');

const upasaleForBusinessTariffs: UpsaleForBusinessTariffs = getFeature('upsale-for-business-tariffs') || {
    month: [
        'W256GB_1m_business_discount_force_trial',
        'W512GB_1m_business_discount_force_trial',
        'W1TB_1m_business_discount_force_trial',
        'W2TB_1m_business_discount_force_trial',
        'W4TB_1m_business_discount_force_trial',
    ],
    year: [
        'W256GB_1y_business_discount_force_trial',
        'W512GB_1y_business_discount_force_trial',
        'W1TB_1y_business_discount_force_trial',
        'W2TB_1y_business_discount_force_trial',
        'W4TB_1y_business_discount_force_trial',
    ],
};

export const upsaleForBusiness = {
    enabled: (isOverquotaUser: boolean) =>
        isUspaleForBusiness === 'b' && !IS_WEBVIEW && !IS_MOBILE_BROWSER && !IS_BIZ_USER && !isOverquotaUser,
    tariffs: upasaleForBusinessTariffs,
} as const;

registerExperiment(
    'upsale-business',
    isUspaleForBusiness,
    [
        AnalyticEventNames.UPSALE_MULTI_MODAL_SHOW,
        AnalyticEventNames.UPSALE_MULTI_MODAL_SWITCH,
        AnalyticEventNames.UPSALE_MULTI_MODAL__CONTINUE,
        AnalyticEventNames.UPSALE_MULTI_MODAL_CLOSE,
    ],
    {
        mapEventNames: {
            UPSALE_MULTI_MODAL_SHOW: 'show',
            UPSALE_MULTI_MODAL_SWITCH: 'switch',
            UPSALE_MULTI_MODAL__CONTINUE: 'continue',
            UPSALE_MULTI_MODAL_CLOSE: 'close',
        },
    }
);
